import { Pagination as RaPagination } from 'react-admin';
import { perPageOptions } from 'utils/helpers';

const Pagination = props => <RaPagination {...props} rowsPerPageOptions={perPageOptions} />;

export default Pagination;
